// @ts-strict-ignore
import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewContainerRef} from '@angular/core';
import {LMModel} from '@form/model';
import { LMFormLayoutService } from '@form/services';

enum LMElementLayoutType {
  FIELD = 0,
  CHECK_CONTROL,
  HEADER,
  PARAGRAPH,
  BUTTON,
  BLANK,
  TEXT,
  MENU,
  MANUAL_REPRESENTATION
}

@Component({
  selector:    'lm-element',
  templateUrl: './lm-element-layout.component.html',
  styleUrls:   [ './lm-element-layout.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMElementLayoutComponent implements OnInit {
  @Input() layoutObject: LMFormLayoutElements;
  @Input() specFields: LMSpecFields;
  @Input() placeHolder: ViewContainerRef;
  @Input() model: LMModel;
  @Input() layoutInfo: LMFormLayoutInfo;
  @Input() lmColumnLayoutInfo: LMColumnLayoutInfo;
  @Input() lmParagraphLayoutInfo: LMParagraphLayoutInfo;

  @Output() fieldEvent: EventEmitter<LMFieldEvent> = new EventEmitter<LMFieldEvent>();

  public elements: Array<LMFormLayoutElement>;
  layoutType;

  constructor(
      private lmFormLayoutService: LMFormLayoutService
  ) {
    this.layoutType = LMElementLayoutType;
  }

  ngOnInit() {
    this.elements = this.layoutObject.elements;

    if (this.elements === undefined) {
      return;
    }

    this.elements.forEach((element: LMFormLayoutElement, i) => {
      element.index = i;
      if (element.field) {
        element.elementLayout = this.layoutType.FIELD;

      } else if (element.checkcontrol) {
        element.elementLayout = this.layoutType.CHECK_CONTROL;

      } else if (element.header) {
        element.elementLayout = this.layoutType.HEADER;

      } else if (element.paragraph) {
        element.elementLayout = this.layoutType.PARAGRAPH;

      } else if (element.button) {
        element.elementLayout = this.layoutType.BUTTON;

      } else if (element.Blank) {
        element.elementLayout = this.layoutType.BLANK;

      } else if (element.text) {
        element.elementLayout = this.layoutType.TEXT;

      } else if (element.menu) {
        element.elementLayout = this.layoutType.MENU;

      } else if (element.manualrep) {
        element.elementLayout = this.layoutType.MANUAL_REPRESENTATION;

      } else if (element.captchaControl) {
        element.elementLayout = this.layoutType.CAPTCHA_CONTROL;
      }
    });

    this.lmFormLayoutService.calculatePreviousHeaderSiblings(this.elements, 2);
  }

  public onFieldEvent(event) {
    this.fieldEvent.emit(event);
  }

  public trackByIndex(index: number, element: LMFormLayoutElement): number {
    return element.index;
  }
}
